import {svgIconWrapper} from '../svg-icon-wrapper';

import PlusRegular from './plus-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <PlusRegular {...props} />;
}

SvgComponent.iconName = 'plusRegular';

export const PlusRegularIcon = svgIconWrapper(SvgComponent);
